module.exports = __webpack_public_path__ + "img/shopify-bag.a5a3d0ab.png";